module.exports = __webpack_public_path__ + "img/Katarina_acc_08.16424804.jpg";